"use client";

import Link from "next/link";
import type { ComponentProps } from "react";
import { usePageTransition } from "@/lib/page-transition-context";

type Props = ComponentProps<typeof Link>;

export function TransitionLink({ href, onClick, ...props }: Props) {
  const navigate = usePageTransition();
  const path = typeof href === "string" ? href : href.pathname ?? "/";

  return (
    <Link
      href={href}
      {...props}
      onClick={(e) => {
        onClick?.(e);
        if (e.defaultPrevented) return;
        e.preventDefault();
        navigate(path);
      }}
    />
  );
}
